import React from "react";
import * as Route from "@/routes";
import {
  EyeOutlined,
  HomeOutlined,
  SecurityScanOutlined,
  SolutionOutlined,
  AuditOutlined
} from "@ant-design/icons/lib";

interface IMenuPathItem {
  title: string;
  icon: React.ComponentType<any>;
  paths: ModuleRoute[];
}

const menuPathItems: IMenuPathItem[] = [
  {
    title: "Home",
    icon: () => <HomeOutlined />,
    paths: Route.homeRoutes
  },
  {
    title: "Watchlist",
    icon: () => <EyeOutlined />,
    paths: Route.wlistRoutes
  },
  {
    title: "Dashboard",
    icon: () => <SolutionOutlined />,
    paths: Route.dashboardRoutes
  },
  {
    title: "Detection",
    icon: () => <SecurityScanOutlined />,
    paths: Route.dectRoutes
  },
];

export default menuPathItems;
